import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import CaseStudyPage from './pages/CaseStudyPage';
import PersonalisationCaseStudy from './pages/PersonalisationCaseStudy';
import CocoCaseStudy from './pages/CocoCaseStudy';
import ShotsCaseStudy from './pages/ShotsCaseStudy';
import SpecialsCaseStudy from './pages/SpecialsCaseStudy';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/case/personalisation-myjio" element={<PersonalisationCaseStudy />} />
        <Route path="/case/coco-integration-tataplay" element={<CocoCaseStudy />} />
        <Route path="/case/shots-tataplay" element={<ShotsCaseStudy />} />
        <Route path="/case/specials-destination-page" element={<SpecialsCaseStudy />} />
        <Route path="/case/:slug" element={<CaseStudyPage />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
